import TeamPage from './TeamPage';
export default TeamPage;
